import React, { useEffect } from 'react';
import bowser from 'yola-bowser';
import { i18next } from '@yola/ws-sdk';
import { reactDnD, ElementDragLayer } from '@yola/ws-ui';
import dragTypes from '../constants/drag-types';
import shouldRenderLabeledDragTrigger from '../helpers/should-render-labeled-drag-trigger';

const { useDragLayer } = reactDnD;

const DRAG_TRIGGER_LEFT_SHIFT = 8;
const DRAG_TRIGGER_TOP_SHIFT = 6;

function handleMouseDown(e) {
  const dragTrigger = document.querySelector('.ws-drag-trigger-wrapper');

  if (bowser.safari && dragTrigger && dragTrigger.contains(e.target)) {
    document.body.classList.add('ws-user-select-none');
  }
}

function handleMouseUp() {
  if (bowser.safari && document.body.classList.contains('ws-user-select-none')) {
    document.body.classList.remove('ws-user-select-none');
  }
}

function ElementDragLayerContainer() {
  const { itemType, clientOffset, draggingItem } = useDragLayer((monitor) => ({
    itemType: monitor.getItemType(),
    clientOffset: monitor.getClientOffset(),
    draggingItem: monitor.getItem(),
  }));

  useEffect(() => {
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, []);

  if (!draggingItem || !clientOffset || itemType !== dragTypes.VIEW_ELEMENT) {
    return null;
  }

  return (
    <ElementDragLayer
      text={i18next.t('Move Element')}
      style={{
        top: clientOffset.y - DRAG_TRIGGER_TOP_SHIFT,
        left: clientOffset.x - DRAG_TRIGGER_LEFT_SHIFT,
      }}
      {...(shouldRenderLabeledDragTrigger(draggingItem.elementId) && {
        glyph: 'drag',
        glyphSize: 24,
        glyphStrokeWidth: 1.3,
        className: 'ws-element-drag-layer--drag-trigger-labeled',
      })}
    />
  );
}

export default ElementDragLayerContainer;
